// extracted by mini-css-extract-plugin
module.exports = {"testReportContainer":"styles__testReportContainer--2RF_u","tableContainer":"styles__tableContainer--1xHxW","tableNotCollapsed":"styles__tableNotCollapsed--2tPX_"};